import { render } from "./AllTeamsListV2.vue?vue&type=template&id=28ce4228&scoped=true"
import script from "./AllTeamsListV2.vue?vue&type=script&lang=js"
export * from "./AllTeamsListV2.vue?vue&type=script&lang=js"

import "./AllTeamsListV2.vue?vue&type=style&index=0&id=28ce4228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ce4228"]])

export default __exports__